import React, { useEffect, useState } from "react";
import { FormControl, Typography, TextField, Tooltip, Box } from '@material-ui/core';
import HelpOutlineIcon from '@material-ui/icons/HelpOutline';
import DefaultSettings from './settings';

export default function TextBox(props) {
    const { value, handleFieldValue, multiline, extraProps, rowsMax, error, required, tooltip, contexthelp, className, disabled, changefieldto, FieldIsSpellCheck, ...otherProps } = props;
    const { label, helperText, name, xtype, fullWidth, inputProps, ...otherConfigs } = otherProps;

    const [currentVal, setCurrentVal] = useState(value);
    const [isLabelTooLong, setIsLabelTooLong] = useState(false);

    useEffect(() => {
        setCurrentVal(value);
        if (error && currentVal !== value) {
            handleFieldValue({ target: { value: value, name: name, checked: false }, currentTarget: { dataset: null } });
        }

        // Check if the label is too long
        const labelElement = document.createElement('div');
        labelElement.style.position = 'absolute';
        labelElement.style.visibility = 'hidden';
        labelElement.style.whiteSpace = 'nowrap';
        labelElement.innerText = label;
        document.body.appendChild(labelElement);
        const labelWidth = labelElement.offsetWidth;
        document.body.removeChild(labelElement);

        if (labelWidth > 650) { // Adjust the width threshold as needed
            setIsLabelTooLong(true);
        } else {
            setIsLabelTooLong(false);
        }
    }, [value, label]);

    let tlabel = (
        <Typography
            variant={value || disabled ? ((isLabelTooLong && value) ? 'caption' : 'h6') : 'caption'}
            color={error ? 'red' : ''}
            style={{
                display: 'block', whiteSpace: 'normal', wordWrap: 'break-word',
                color: isLabelTooLong ? '#6c757d' : ''
            }}
        >
            {label}
            {required ? <strong style={{ color: 'red' }}>{' * '}</strong> : ''}
            {tooltip && (
                <Tooltip title={tooltip ? tooltip : null} placement="bottom-start">
                    <HelpOutlineIcon
                        color='secondary'
                        fontSize="small"
                        style={{ width: '0.6em', marginBottom: 5, marginLeft: 5 }}
                        onClick={(evt) => contexthelp ? DefaultSettings.showDrawer(contexthelp) : evt.preventDefault()}
                    />
                </Tooltip>
            )}
        </Typography>
    );

    return (
        <FormControl className={className} fullWidth={fullWidth ? fullWidth : true} error={error}>
            {isLabelTooLong && currentVal && (
                <div>
                    {tlabel}
                </div>
            )}
            <TextField
                disabled={disabled || false}
                error={error}
                fullWidth={fullWidth ? fullWidth : true}
                label={!isLabelTooLong || !currentVal ? tlabel : ''}
                InputProps={{
                    inputProps: { ...inputProps, style: { fontWeight: 500 } }
                }}
                multiline={multiline || (changefieldto === 'TA' ? true : false)}
                maxRows={rowsMax || 3}
                value={currentVal}
                type={xtype || 'text'}
                onChange={(evt) => { setCurrentVal(evt.target.value) }}
                onBlur={() => {
                    handleFieldValue({ target: { value: currentVal, name: name, checked: false }, currentTarget: { dataset: null } });
                }}
                InputLabelProps={{
                    shrink: (disabled || currentVal) ? true : false,
                }}
                name={name}
                helperText={helperText}
                {...otherConfigs}
                {...extraProps}
                spellCheck={FieldIsSpellCheck === 'Y' ? true : false}
            />
        </FormControl>
    );
}